import { Zap, Package as PackageIcon, Flame, Sparkles, Ticket } from "lucide-react";
import { fmtARS } from "../lib/utils-app";
import { HangingSpider } from "./Halloween";

export default function EvolutivoCard({ product, selected, onSelect, theme }) {
  const isCard = product.category === "tarjetas";
  const Icon = isCard ? Ticket : product.id === "evo_token" ? Sparkles : PackageIcon;
  return (
    <button
      type="button"
      onClick={() => onSelect(product)}
      data-testid={`package-card-${product.id}`}
      className={`pkg-card relative w-full min-w-0 rounded-xl p-3 sm:p-5 text-left overflow-hidden`}
      style={{
        border: `1px solid ${selected ? theme.primary : "rgba(255,69,0,0.25)"}`,
        boxShadow: selected ? `0 0 0 2px ${theme.primary}55, 0 12px 40px ${theme.primary}44` : "none",
      }}
    >
      <HangingSpider length={10} />
      <div className="relative h-6 mb-2 flex items-center gap-2 pr-10">
        {product.bonus && (
          <span className="badge-hot text-[10px] px-2 py-0.5 rounded-md tracking-wider">{product.bonus}</span>
        )}
        {product.popular && product.bonus !== "POPULAR" && (
          <span className="flex items-center gap-1 text-[10px] tracking-widest" style={{ color: theme.primary }}>
            <Flame className="w-3 h-3" /> POPULAR
          </span>
        )}
      </div>

      <div className="relative flex items-center gap-3 mb-3">
        <div
          className="w-11 h-11 rounded-md grid place-items-center shrink-0"
          style={{ background: "#0f0f0f", border: `1px solid ${theme.primary}66`, filter: `drop-shadow(0 0 8px ${theme.primary}88)` }}
        >
          <Icon className="w-6 h-6" style={{ color: theme.primary }} strokeWidth={2} />
        </div>
        <div className="min-w-0">
          <div className="font-display text-xl leading-tight tracking-wider text-white break-words">
            {product.name}
          </div>
          <div className="text-[10px] text-neutral-400 uppercase tracking-widest">
            {isCard ? "Tarjeta · se acredita sola" : `Mínimo ${product.min_qty || 1}`}
          </div>
        </div>
      </div>

      <div className="relative flex flex-wrap items-end justify-between gap-2 pt-3 border-t border-white/5">
        <div>
          <div className="text-[10px] uppercase tracking-widest text-neutral-500">{isCard ? "Precio" : "Precio c/u"}</div>
          <div className="text-lg font-bold text-white">{fmtARS(product.unit_price_ars)}</div>
        </div>
        <div
          className="text-xs px-2 py-1 rounded-md flex items-center gap-1"
          style={{
            background: selected ? theme.primary : "rgba(255,255,255,0.05)",
            color: selected ? "#000" : "#d4d4d4",
          }}
        >
          <Zap className="w-3 h-3" /> {selected ? "SELECCIONADO" : "ELEGIR"}
        </div>
      </div>
    </button>
  );
}
